import React from "react";
import {
  MenuItemContainer,
  MenuItemText,
  IconContainer,
  SubmenuDot,
  MenuBadgeContainer,
} from "./styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Tooltip from "@mui/material/Tooltip";

interface MenuItemProps {
  isActive: boolean;
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
  hasSubMenu?: boolean;
  isSubmenu?: boolean;
  isSubmenuOpen?: boolean;
  children?: React.ReactNode;
  isFirstItem?: boolean;
  arrowChange?: boolean;
  disabled?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  text,
  onClick,
  isActive,
  hasSubMenu,
  isSubmenu,
  isSubmenuOpen,
  isFirstItem,
  children,
  arrowChange,
  disabled,
}) => {
  const isParentActive = Boolean(isActive || (hasSubMenu && isSubmenuOpen && arrowChange));
  const arrowStyle = {
    width: "18px",
    height: "18px",
    color: isParentActive ? "#0095ff" : "#595959",
  };

  const itemContent = (
    <MenuItemContainer
      onClick={disabled ? (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() : onClick}
      isActive={isParentActive}
      isSubmenu={isSubmenu}
      isFirstItem={isFirstItem}
      $disabled={disabled}
    >
      {isSubmenu ? (
        <SubmenuDot isActive={isActive} />
      ) : (
        <MenuBadgeContainer isActive={isParentActive}>
          {icon}
        </MenuBadgeContainer>
      )}
      <MenuItemText isSubmenu={isSubmenu} isActive={isSubmenu ? isActive : isParentActive} $disabled={disabled}>
        {text}
      </MenuItemText>
      <IconContainer>
        {hasSubMenu &&
          (isSubmenuOpen && arrowChange ? (
            <ExpandLessIcon style={arrowStyle} />
          ) : (
            <ExpandMoreIcon style={arrowStyle} />
          ))}
      </IconContainer>
    </MenuItemContainer>
  );

  return (
    <>
      {disabled ? (
        <Tooltip title="Coming Soon" placement="right" arrow>
          <span style={{ display: "block" }}>{itemContent}</span>
        </Tooltip>
      ) : (
        itemContent
      )}
      {children}
    </>
  );
};

export default MenuItem;
